// extracted by mini-css-extract-plugin
export var form = "form-elem-module--form--1G2Vu";
export var form_flex = "form-elem-module--form_flex--3NJrc";
export var form_field = "form-elem-module--form_field--2-mt5";
export var form_submit = "form-elem-module--form_submit--2IGN6";